'use client';
import { CloseRoundIcon, SearchIcon } from '@/components/icons/svg-icons';
import { searchService } from '@/services/search.service';
import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';
import { searchStyle } from '../search-component.style';
import { useAnalyseAttribute } from '@/features/next-analyse';

interface SearchInputProps {
	autoCompleteDatas ?: Array<string>,
    setAutoCompleteResults : (value: Array<string>) => void;
} 
const findAutocomplete = (input: string, data: Array<string>) => {
	const result = data.filter((item) => {
		return item.toLowerCase().includes(input.toLowerCase());
	});
	return result ?? [];
}
export const SearchInput = ({
	autoCompleteDatas,
	setAutoCompleteResults,
}: SearchInputProps) => {
	const t = useTranslations('General');
	const placeHolder = t('lbl_SearchLeague');
	const input = useAnalyseAttribute('click-search-input');
	
	useEffect(() => {
		searchService.setSearchInput('');
	}, []);
	
	useEffect(() => {
		if (input.current) {
			input.current.value = searchService.searchInputValue;
		}
	}, [searchService.searchInputValue]);
	
	const removeInput = () => {
		if (input.current) {
			input.current.value = '';
			searchService.setSearchInput('');
			setAutoCompleteResults([]);
		}
	}
	
	const onFocus = () => {}
	
	const onChange = (e: React.ChangeEvent<HTMLInputElement>, autoCompleteDatas: Array<string>) => {
		searchService.setSearchInput(e.target.value);
		const input = searchService.searchInputValue;
		if (input !== '') {
			let result = findAutocomplete(input, autoCompleteDatas);
			const input2 = input.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
			const regex = new RegExp(input2, 'i');
			result = result.filter((item) => regex.test(item));
			if ((input.length== 1 || input.length == 2)&& result.length > 20) result = result.slice(0, 20);
			setAutoCompleteResults(result);
		} else {
			setAutoCompleteResults([]);
		}
	}
	
	// IME 組合事件處理，避免中文輸入問題
	const onCompositionStart = () => {
		// 標記正在進行 IME 組合
		if (input.current) {
			input.current.dataset.composing = 'true';
		}
	}
	
	const onCompositionEnd = (e: React.CompositionEvent<HTMLInputElement>) => {
		// IME 組合結束，觸發搜索
		if (input.current) {
			delete input.current.dataset.composing;
			onChange(e as any, autoCompleteDatas ?? []);
		}
	}
	
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		// 如果正在進行 IME 組合，不觸發搜索
		if (input.current?.dataset.composing === 'true') {
			return;
		}
		onChange(e, autoCompleteDatas ?? []);
	}
	
	const onKeyDown = () => {

	}
	return (
		<div className="search-input">
			<div className={searchStyle.searchIcon}>
				<SearchIcon />
			</div>
			<input ref={input}
				className="input"
				placeholder={placeHolder}
				type="text"
				onFocus={onFocus}
				onChange={handleChange}
				onCompositionStart={onCompositionStart}
				onCompositionEnd={onCompositionEnd}
				onKeyDown={onKeyDown}
				required
			/>
			<button
				className="btn btn--icon"
				onClick={() => removeInput()}
			>
				<CloseRoundIcon  />
			</button>
		</div>
	);
}